import React from "react";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import './Common.css';
import { useForm } from "react-hook-form";
import { RequestLocation } from "../LocationComponents/RequestLocation";
import { DisplayToaster } from "../../core/services/sharedService";

type Props = {
    addBtnDisable?: boolean,
    disable?: any,
    heading: string,
    tenant?: any,
    to?: string,
    action?: string,
    className?: string,
    id?: string,
    ToasterMessage?: string,
    showPopup?: boolean
}

const TopHeader = ({ addBtnDisable, disable, heading, tenant, to, action, className, id, ToasterMessage, showPopup }: Props) => {
    const copyme = () => {
        let textField = document.createElement('textarea');
        textField.innerText = tenant;
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        textField.remove();
        DisplayToaster("bg-success", "Customer ID copied to clipboard!");
    }
    const navigate = useNavigate();

    const [showPopups, setShowPopups] = React.useState<boolean | undefined>(showPopup === undefined ? undefined : false);

    const NavigateToPage = (e: any) => {
        e.preventDefault();
        (showPopups === undefined) ? navigate("" + to) : setShowPopups(true);
    }

    const { resetField } = useForm<any>();

    const formKeys = ['location_name', 'address', 'state', 'city', 'message'];

    const resetInputFields = (data: any) => {
        data.map((item: any) => resetField(item))
    }

    const handleReset = () => {
        setShowPopups(false);
        resetInputFields(formKeys);
    };

    let margin = (process.env.REACT_APP_AGENT === localStorage.getItem("event") ? "mt-4" : "mt-3");

    return (
        <>
            <div className={'align-items-center d-flex ' + margin}>
                <div className='col-sm-6'>
                    <h2 className="heading-font head-heading"><span className="header_underline">{heading}</span></h2>
                </div>

                {action &&
                    <div className='col-sm-6 d-flex justify-content-end'>
                        {tenant && <button className="btn btn-primary btn-sm buttons mt-3 app-button-color app-button-copyMe-button" id="copy-customer-id" title={tenant} onClick={copyme} ><i className="bi bi-clipboard2-plus-fill" aria-hidden="true"></i> Copy Customer ID</button>}
                        {/* {disable ? <Link to={"" + to} className="text-white link-text disabledCursor" onClick={(event) => event.preventDefault()}><Button className="m-3 buttons app-button-color" disabled={disable} style={{ background: '#0187c4' }} ><i className={className} aria-hidden="true"></i>{" " + action}</Button></Link>:<Link to={"" + to} className="text-white link-text"><Button className="m-3 buttons app-button-color" style={{ background: '#0187c4' }} ><i className={className} aria-hidden="true"></i>{" " + action}</Button></Link>} */}
                        {/* <Link to={"" + to} className="text-white link-text"> */}
                        <Button className="m-3 buttons app-button-color" id={id} onClick={(e) => { NavigateToPage(e) }} style={{ background: '#0187c4' }} ><i className={className} aria-hidden="true"></i>{" " + action}</Button>
                        {/* </Link> */}
                    </div>
                }
            </div>
            {showPopups && <RequestLocation showPopups={showPopups} handleReset={handleReset} />}
        </>
    )
}

export default TopHeader;